import React from 'react'
import Coupon from '../Coupon/Coupon'

const CouponList = ({coupons, setModalOpen, handleCouponCodeResponse, setCouponDetails, parentValues, params, setDrawerOpen, setApplyCouponErr, token, setApplyCouponLoading,
  applyCouponLoading}) => {
  return (
    <div className='couponList'>
     
        {coupons?.map(item => <Coupon setApplyCouponErr={setApplyCouponErr} setDrawerOpen={setDrawerOpen} params={params} handleCouponCodeResponse={handleCouponCodeResponse} parentValues={parentValues} title={item?.couponcode} coupon={item} setModalOpen={setModalOpen} setCouponDetails={setCouponDetails} 
          setApplyCouponLoading = {setApplyCouponLoading}
          applyCouponLoading = {applyCouponLoading}
          token={token}
        />)}
    </div>
  )
}

export default CouponList
